module.exports = __webpack_public_path__ + "static/media/background.3a1f0cfc.png";